module.exports = __webpack_public_path__ + "media/our_mission/photo_0-65a2efd4.webp";